import { render, staticRenderFns } from "./AdminSocieteContact.vue?vue&type=template&id=5d1b200a"
import script from "./AdminSocieteContact.vue?vue&type=script&lang=js"
export * from "./AdminSocieteContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports